import Raven from 'raven-js';
import { buildInteractiveCardRequestMessage } from 'conversations-message-history/interactive-card-request-message/operators/buildInteractiveCardRequestMessage';
import { buildCMFSender } from 'conversations-message-history/common-message-format/operators/buildCMFSender';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import { LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { CHANNEL_SPECIFIC_OPAQUE_ID } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
// @ts-ignore Untyped Module
import { publishMessageToConversation } from '../../actions/PublishActions/publishMessageToConversation';
import { getChannelInstanceId } from '../../selectors/widgetDataSelectors/getChannelInstanceId';
import { getMessagesUtk } from '../../query-params/getMessagesUtk';
// @ts-ignore Untyped Module
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getThreadId, getChannelName } from '../../threads/operators/threadGetters';
import { getInteractiveCardByInstanceId } from '../selectors/getInteractiveCardByInstanceId';
import { cardActionPending } from '../slice/interactiveCardsSlice';
import { serializeContextForChirp } from '../operators/serializeContextForChirp';
import { registerPendingActionTimeout } from './interactiveCardTimeouts';
import { refetchCardAfterTimeout } from './refetchCardAfterTimeout';
const CARD_ACTION_TIMEOUT_MS = 15000;
export const publishInteractiveCardAction = ({
  cardInstanceId,
  cardId,
  actionName,
  payload
}) => (dispatch, getState) => {
  var _card$stateName, _getChannelInstanceId;
  const state = getState();
  const selectedThread = getSelectedThread(state);
  const threadId = getThreadId(selectedThread);
  const channel = getChannelName(selectedThread);
  const card = getInteractiveCardByInstanceId(state, cardInstanceId);
  if (!card) {
    return;
  }
  const messagesUtk = getMessagesUtk();
  if (!messagesUtk) {
    Raven.captureMessage('publishInteractiveCardAction: unable to determine messagesUtk', {
      level: 'warning'
    });
    return;
  }
  const deliveryIdentifier = {
    type: CHANNEL_SPECIFIC_OPAQUE_ID,
    value: messagesUtk
  };
  const message = buildInteractiveCardRequestMessage({
    actionName,
    cardId: cardId !== null && cardId !== void 0 ? cardId : '',
    cardInstanceId,
    cardInstanceVersion: card.cardInstanceVersion,
    context: serializeContextForChirp(payload),
    currentStateName: (_card$stateName = card.stateName) !== null && _card$stateName !== void 0 ? _card$stateName : '',
    senders: [buildCMFSender({
      deliveryIdentifier
    })],
    channelInstanceId: (_getChannelInstanceId = getChannelInstanceId(state)) !== null && _getChannelInstanceId !== void 0 ? _getChannelInstanceId : undefined,
    genericChannelId: LIVE_CHAT_GENERIC_CHANNEL_ID,
    direction: INCOMING
  });
  dispatch(cardActionPending({
    cardInstanceId,
    actionName
  }));
  dispatch(publishMessageToConversation({
    channel,
    message,
    threadId
  }));
  registerPendingActionTimeout(cardInstanceId, () => {
    void dispatch(refetchCardAfterTimeout(cardInstanceId));
  }, CARD_ACTION_TIMEOUT_MS);
};